import { type SlipSize, slipSizeSchema } from '#shared/types';
import { readStored, writeStored } from '#client/lib/storage';

/**
 * Which paper the slip was last printed on, per browser.
 *
 * Not per user and not on the server: this is a property of the machine at the
 * desk — which tray is loaded, whether a receipt printer is plugged into this
 * terminal — rather than of the person signed into it. The front desk's PC has a
 * thermal roll and the back office has A4, and neither wants to re-pick every
 * time.
 *
 * Validated on the way out of storage rather than trusted. It is user-editable,
 * and an unvalidated read would put `?size=junk` on the print URL and turn a
 * remembered preference into a 400 nobody can explain.
 */

const KEY = 'ndc.print.slipSize';

const DEFAULT: SlipSize = 'A5';

export function readSlipSize(): SlipSize {
  const parsed = slipSizeSchema.safeParse(readStored(KEY));
  return parsed.success ? parsed.data : DEFAULT;
}

export function writeSlipSize(size: SlipSize): void {
  writeStored(KEY, size);
}
